let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gwcR6")).then(() => parcelRequire('dN7WS'));